import { makeStyles, Theme, createStyles } from '@material-ui/core'
import colors from '../../../styles/colors'
import fonts from '../../../styles/fonts'

/**
 * Trilha do mockup Lovable: níveis navegáveis em `brand`, separador `/` em
 * texto secundário e o nível atual em texto principal.
 */
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    breadcrumbText: {
      color: colors.purple,
      fontFamily: fonts.interComponent,
      fontSize: '0.875rem',
      cursor: 'pointer',
      '&:hover': { textDecoration: 'underline' },
    },
    breadcrumbCurrent: {
      color: colors.blackMedium,
      fontFamily: fonts.interComponent,
      fontSize: '0.875rem',
    },
    breadcrumbSeparator: {
      color: colors.grayMedium,
      fontFamily: fonts.interComponent,
      fontSize: '0.875rem',
    },
    boxBreadItens: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  }),
)
